import { array as codecArray } from 'purify-ts/Codec';
import { makeResponses } from '../response_factory';
import { utils as coreUtils, paginated, requestParams } from '@codegrade/api-core';
import { AnalyticsData, AssignmentGradebookRow, AssignmentGrader, AssignmentIPRange, AssignmentPasswordResponse, AssignmentPeerFeedbackConnection, AssignmentPeerFeedbackSettings, AssignmentTimeframes, AutoTest, CopyRubricAssignmentData, CreatePlagiarismRunAssignmentData, DivideGradersAssignmentData, ExportAssignmentData, ExtendedAssignment, ExtendedAssignmentTemplate, ExtendedWork, ImportIntoAssignmentData, Job, PatchAssignmentData, PatchRubricCategoryTypeAssignmentData, PatchSubmitTypesAssignmentData, PlagiarismRun, PutDescriptionAssignmentData, PutDivisionParentAssignmentData, PutPasswordAssignmentData, PutRubricAssignmentData, RubricRowBase, UpdatePeerFeedbackSettingsAssignmentData, UploadSubmissionAssignmentData, UserLoginResponse, VerifyAssignmentData, WebhookBase, Work, WorkCommentCount, } from '@codegrade/api-models';
import { parsers } from '@codegrade/utils';
const makeResult = coreUtils.makeResult;
// eslint-disable-next-line @typescript-eslint/no-unused-vars,unused-imports/no-unused-vars
const parseJsonResponse = /* #__PURE__ */ parsers.parseJsonResponse;
export function assignment(config) {
    const putRubricResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(
        /* #__PURE__ */ parseJsonResponse(/* #__PURE__ */ codecArray(RubricRowBase))),
    });
    const deleteRubricResponse = /* #__PURE__ */ makeResponses({
        204: /* #__PURE__ */ makeResult(async () => null),
    });
    const getRubricResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ paginated.makeResult(
        /* #__PURE__ */ parseJsonResponse(/* #__PURE__ */ codecArray(RubricRowBase))),
    });
    const putDivisionParentResponse = /* #__PURE__ */ makeResponses({
        204: /* #__PURE__ */ makeResult(async () => null),
    });
    const patchRubricCategoryTypeResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(/* #__PURE__ */ parseJsonResponse(RubricRowBase)),
    });
    const deleteResponse = /* #__PURE__ */ makeResponses({
        204: /* #__PURE__ */ makeResult(async () => null),
    });
    const getResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(/* #__PURE__ */ parseJsonResponse(ExtendedAssignment)),
    });
    const patchResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(/* #__PURE__ */ parseJsonResponse(ExtendedAssignment)),
    });
    const deleteDescriptionResponse = /* #__PURE__ */ makeResponses({
        204: /* #__PURE__ */ makeResult(async () => null),
    });
    const getDescriptionResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(/* #__PURE__ */ parsers.parseArrayBufferResponse),
    });
    const putDescriptionResponse = /* #__PURE__ */ makeResponses({
        204: /* #__PURE__ */ makeResult(async () => null),
    });
    const deletePasswordResponse = /* #__PURE__ */ makeResponses({
        204: /* #__PURE__ */ makeResult(async () => null),
    });
    const getPasswordResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(
        /* #__PURE__ */ parseJsonResponse(AssignmentPasswordResponse)),
    });
    const putPasswordResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(
        /* #__PURE__ */ parseJsonResponse(AssignmentPasswordResponse)),
    });
    const deleteTemplateResponse = /* #__PURE__ */ makeResponses({
        204: /* #__PURE__ */ makeResult(async () => null),
    });
    const getTemplateResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(
        /* #__PURE__ */ parseJsonResponse(ExtendedAssignmentTemplate)),
    });
    const deleteTemplateFileResponse = /* #__PURE__ */ makeResponses({
        204: /* #__PURE__ */ makeResult(async () => null),
    });
    const getTemplateFileResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(/* #__PURE__ */ parsers.parseArrayBufferResponse),
    });
    const deleteAllowedIpResponse = /* #__PURE__ */ makeResponses({
        204: /* #__PURE__ */ makeResult(async () => null),
    });
    const putAllowedIpResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(/* #__PURE__ */ parseJsonResponse(AssignmentIPRange)),
    });
    const disablePeerFeedbackResponse = /* #__PURE__ */ makeResponses({
        204: /* #__PURE__ */ makeResult(async () => null),
    });
    const updatePeerFeedbackSettingsResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(
        /* #__PURE__ */ parseJsonResponse(AssignmentPeerFeedbackSettings)),
    });
    const divideGradersResponse = /* #__PURE__ */ makeResponses({
        204: /* #__PURE__ */ makeResult(async () => null),
    });
    const exportResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(/* #__PURE__ */ parseJsonResponse(Job)),
    });
    const getAllGradesResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ paginated.makeResult(
        /* #__PURE__ */ parseJsonResponse(/* #__PURE__ */ codecArray(AssignmentGradebookRow))),
    });
    const getAllGradersResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ paginated.makeResult(
        /* #__PURE__ */ parseJsonResponse(/* #__PURE__ */ codecArray(AssignmentGrader))),
    });
    const getSubmissionsByUserResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ paginated.makeResult(
        /* #__PURE__ */ parseJsonResponse(/* #__PURE__ */ codecArray(Work))),
    });
    const getAllSubmissionsResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ paginated.makeResult(
        /* #__PURE__ */ parseJsonResponse(/* #__PURE__ */ codecArray(Work))),
    });
    const getAnalyticsDataResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ paginated.makeResult(
        /* #__PURE__ */ parseJsonResponse(/* #__PURE__ */ codecArray(AnalyticsData))),
    });
    const getAllAllowedIpsResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ paginated.makeResult(
        /* #__PURE__ */ parseJsonResponse(/* #__PURE__ */ codecArray(AssignmentIPRange))),
    });
    const getTimeframesResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(/* #__PURE__ */ parseJsonResponse(AssignmentTimeframes)),
    });
    const putTimeframesResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(/* #__PURE__ */ parseJsonResponse(AssignmentTimeframes)),
    });
    const getAutoTestResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(/* #__PURE__ */ parseJsonResponse(AutoTest)),
    });
    const getWebhookSettingsResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(/* #__PURE__ */ parseJsonResponse(WebhookBase)),
    });
    const getNextUngradedSubmissionResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(/* #__PURE__ */ parseJsonResponse(ExtendedWork)),
    });
    const getPeerFeedbackSubjectsResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ paginated.makeResult(
        /* #__PURE__ */ parseJsonResponse(
        /* #__PURE__ */ codecArray(AssignmentPeerFeedbackConnection))),
    });
    const getAllPlagiarismRunsResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ paginated.makeResult(
        /* #__PURE__ */ parseJsonResponse(/* #__PURE__ */ codecArray(PlagiarismRun))),
    });
    const getReplyCountsForUserResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ paginated.makeResult(
        /* #__PURE__ */ parseJsonResponse(/* #__PURE__ */ codecArray(WorkCommentCount))),
    });
    const importIntoResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(/* #__PURE__ */ parseJsonResponse(ExtendedAssignment)),
    });
    const copyRubricResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(
        /* #__PURE__ */ parseJsonResponse(/* #__PURE__ */ codecArray(RubricRowBase))),
    });
    const markGraderAsDoneResponse = /* #__PURE__ */ makeResponses({
        204: /* #__PURE__ */ makeResult(async () => null),
    });
    const markGraderAsNotDoneResponse = /* #__PURE__ */ makeResponses({
        204: /* #__PURE__ */ makeResult(async () => null),
    });
    const createPlagiarismRunResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(/* #__PURE__ */ parseJsonResponse(PlagiarismRun)),
    });
    const patchSubmitTypesResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(/* #__PURE__ */ parseJsonResponse(ExtendedAssignment)),
    });
    const uploadSubmissionResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(/* #__PURE__ */ parseJsonResponse(ExtendedWork)),
    });
    const verifyResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(/* #__PURE__ */ parseJsonResponse(UserLoginResponse)),
    });
    return Object.freeze({
        /**
         * Add or update rubric of an assignment.
         *
         * @param arg The arguments to the function.
         * @param arg.assignmentId The id of the assignment
         * @param arg.requestBody The body of the request.
         * @returns The updated or created rubric.
         */
        putRubric: async ({ assignmentId, requestBody, }) => {
            const result = await requestParams(config, 'PUT', `/api/v1/assignments/${assignmentId}/rubrics/`, putRubricResponse.v, JSON.stringify(PutRubricAssignmentData.encode(requestBody)));
            return result;
        },
        /**
         * Delete the rubric for the given assignment.
         *
         * @param arg The arguments to the function.
         * @param arg.assignmentId The id of the `Assignment` whose rubric should be deleted.
         * @returns Nothing.
         */
        deleteRubric: async ({ assignmentId, }) => {
            const result = await requestParams(config, 'DELETE', `/api/v1/assignments/${assignmentId}/rubrics/`, deleteRubricResponse.v, undefined);
            return result;
        },
        /**
         * Return the rubric corresponding to the given `assignment_id`.
         *
         * @param arg The arguments to the function.
         * @param arg.assignmentId The id of the assignment.
         * @param arg.pageSize The size of a single page, maximum is 100.
         * @param arg.nextToken The next token, to retrieve a next page.
         * @returns A list of `RubricRow` items.
         */
        getRubric: async ({ assignmentId, pageSize = undefined, nextToken = undefined, }) => {
            const result = await requestParams(config, 'GET', `/api/v1/assignments/${assignmentId}/rubrics/`, getRubricResponse.v, undefined, {
                'page-size': pageSize,
                'next-token': nextToken,
            });
            return result;
        },
        /**
         * Change the division parent of an assignment.
         *
         * Set the division parent of this assignment. See the documentation about dividing submissions for more information about division parents.
         *
         * @param arg The arguments to the function.
         * @param arg.assignmentId The id of the assignment you want to change.
         * @param arg.requestBody The body of the request.
         * @returns An empty response with status code code 204.
         */
        putDivisionParent: async ({ assignmentId, requestBody, }) => {
            const result = await requestParams(config, 'PUT', `/api/v1/assignments/${assignmentId}/division_parent`, putDivisionParentResponse.v, JSON.stringify(PutDivisionParentAssignmentData.encode(requestBody)));
            return result;
        },
        /**
         * Change the type of a rubric category.
         *
         * @param arg The arguments to the function.
         * @param arg.assignmentId The assignment of the rubric category.
         * @param arg.rubricCategoryId The rubric category you want to change the type of.
         * @param arg.requestBody The body of the request.
         * @returns The updated rubric row.
         */
        patchRubricCategoryType: async ({ assignmentId, rubricCategoryId, requestBody, }) => {
            const result = await requestParams(config, 'PATCH', `/api/v1/assignments/${assignmentId}/rubrics/${rubricCategoryId}/type`, patchRubricCategoryTypeResponse.v, JSON.stringify(PatchRubricCategoryTypeAssignmentData.encode(requestBody)));
            return result;
        },
        /**
         * Delete a given `Assignment`.
         *
         * @param arg The arguments to the function.
         * @param arg.assignmentId The id of the assignment
         * @returns Nothing.
         */
        delete: async ({ assignmentId, }) => {
            const result = await requestParams(config, 'DELETE', `/api/v1/assignments/${assignmentId}`, deleteResponse.v, undefined);
            return result;
        },
        /**
         * Get a single assignment by id.
         *
         * @param arg The arguments to the function.
         * @param arg.assignmentId The id of the assignment you want to get.
         * @returns The requested assignment.
         */
        get: async ({ assignmentId, }) => {
            const result = await requestParams(config, 'GET', `/api/v1/assignments/${assignmentId}`, getResponse.v, undefined);
            return result;
        },
        /**
         * Update the given assignment with new values.
         *
         * @param arg The arguments to the function.
         * @param arg.assignmentId The id of the assignment you want to update.
         * @param arg.requestBody The body of the request.
         * @returns The updated assignment.
         */
        patch: async ({ assignmentId, requestBody, }) => {
            const result = await requestParams(config, 'PATCH', `/api/v1/assignments/${assignmentId}`, patchResponse.v, JSON.stringify(PatchAssignmentData.encode(requestBody)));
            return result;
        },
        /**
         * Deletes the description for a given `Assignment`.
         *
         * @param arg The arguments to the function.
         * @param arg.assignmentId The id of the assignment.
         * @returns An empty response.
         */
        deleteDescription: async ({ assignmentId, }) => {
            const result = await requestParams(config, 'DELETE', `/api/v1/assignments/${assignmentId}/description`, deleteDescriptionResponse.v, undefined);
            return result;
        },
        /**
         * Get the description for this assignment.
         *
         * @param arg The arguments to the function.
         * @param arg.assignmentId The id of the assignment;
         * @returns A public link that allows users to download the file or the file itself as a stream of octets
         */
        getDescription: async ({ assignmentId, }) => {
            const result = await requestParams(config, 'GET', `/api/v1/assignments/${assignmentId}/description`, getDescriptionResponse.v, undefined);
            return result;
        },
        /**
         * Stores a file containing the new description for a given `Assignment`.
         *
         * @param arg The arguments to the function.
         * @param arg.assignmentId The id of the assignment
         * @param arg.requestBody The body of the request.
         * @returns An empty response.
         */
        putDescription: async ({ assignmentId, requestBody, }) => {
            const body = coreUtils.toFormData(PutDescriptionAssignmentData.encode(requestBody));
            const result = await requestParams(config, 'PUT', `/api/v1/assignments/${assignmentId}/description`, putDescriptionResponse.v, body);
            return result;
        },
        /**
         * Remove password protection from an assignment.
         *
         * @param arg The arguments to the function.
         * @param arg.assignmentId The id of the assignment.
         * @returns An empty response.
         */
        deletePassword: async ({ assignmentId, }) => {
            const result = await requestParams(config, 'DELETE', `/api/v1/assignments/${assignmentId}/password`, deletePasswordResponse.v, undefined);
            return result;
        },
        /**
         * Get the password for an assignment (admin only).
         *
         * @param arg The arguments to the function.
         * @param arg.assignmentId The id of the assignment.
         * @returns JSON response with password or null.
         */
        getPassword: async ({ assignmentId, }) => {
            const result = await requestParams(config, 'GET', `/api/v1/assignments/${assignmentId}/password`, getPasswordResponse.v, undefined);
            return result;
        },
        /**
         * Set the password for an assignment.
         *
         * @param arg The arguments to the function.
         * @param arg.assignmentId The id of the assignment.
         * @param arg.requestBody The body of the request.
         * @returns An empty response.
         */
        putPassword: async ({ assignmentId, requestBody, }) => {
            const result = await requestParams(config, 'PUT', `/api/v1/assignments/${assignmentId}/password`, putPasswordResponse.v, JSON.stringify(PutPasswordAssignmentData.encode(requestBody)));
            return result;
        },
        /**
         * Delete the template corresponding to the given `assignment_id`.
         *
         * @param arg The arguments to the function.
         * @param arg.assignmentId The id of the assignment.
         * @returns Nothing.
         */
        deleteTemplate: async ({ assignmentId, }) => {
            const result = await requestParams(config, 'DELETE', `/api/v1/assignments/${assignmentId}/template`, deleteTemplateResponse.v, undefined);
            return result;
        },
        /**
         * Return the template corresponding to the given `assignment_id`.
         *
         * @param arg The arguments to the function.
         * @param arg.assignmentId The id of the assignment.
         * @returns The template for this assignment.
         */
        getTemplate: async ({ assignmentId, }) => {
            const result = await requestParams(config, 'GET', `/api/v1/assignments/${assignmentId}/template`, getTemplateResponse.v, undefined);
            return result;
        },
        /**
         * Delete a single file or directory from the assignment template.
         *
         * @param arg The arguments to the function.
         * @param arg.assignmentId The id of the assignment.
         * @param arg.fileId The id of the file to delete.
         * @returns Nothing.
         */
        deleteTemplateFile: async ({ assignmentId, fileId, }) => {
            const result = await requestParams(config, 'DELETE', `/api/v1/assignments/${assignmentId}/template/${fileId}`, deleteTemplateFileResponse.v, undefined);
            return result;
        },
        /**
         * Get the content of a single file of an assignment template.
         *
         * @param arg The arguments to the function.
         * @param arg.assignmentId The id of the assignment.
         * @param arg.fileId The id of the file.
         * @returns The contents of the requested file.
         */
        getTemplateFile: async ({ assignmentId, fileId, }) => {
            const result = await requestParams(config, 'GET', `/api/v1/assignments/${assignmentId}/template/${fileId}`, getTemplateFileResponse.v, undefined);
            return result;
        },
        /**
         * Delete a single IP range lock from an assignment by ID.
         *
         * @param arg The arguments to the function.
         * @param arg.assignmentId The ID of the assignment.
         * @param arg.ipRange The IP range (or single IP).
         * @returns An empty response.
         */
        deleteAllowedIp: async ({ assignmentId, ipRange, }) => {
            const result = await requestParams(config, 'DELETE', `/api/v1/assignments/${assignmentId}/allowed_ips/${ipRange}`, deleteAllowedIpResponse.v, undefined);
            return result;
        },
        /**
         * Add a single IP range lock to an assignment.
         *
         * @param arg The arguments to the function.
         * @param arg.assignmentId The id of the assignment.
         * @param arg.ipRange The ip range you want to add.
         * @returns A JSON response returning the added item.
         */
        putAllowedIp: async ({ assignmentId, ipRange, }) => {
            const result = await requestParams(config, 'PUT', `/api/v1/assignments/${assignmentId}/allowed_ips/${ipRange}`, putAllowedIpResponse.v, undefined);
            return result;
        },
        /**
         * Disabled peer feedback for an assignment.
         *
         * @param arg The arguments to the function.
         * @param arg.assignmentId The id of the assignment for which you want to disable peer feedback.
         * @returns Nothing; an empty response.
         */
        disablePeerFeedback: async ({ assignmentId, }) => {
            const result = await requestParams(config, 'DELETE', `/api/v1/assignments/${assignmentId}/peer_feedback_settings`, disablePeerFeedbackResponse.v, undefined);
            return result;
        },
        /**
         * Enable peer feedback for an assignment.
         *
         * @param arg The arguments to the function.
         * @param arg.assignmentId The id of the assignment for which you want to enable peer feedback.
         * @param arg.requestBody The body of the request.
         * @returns The just created peer feedback settings.
         */
        updatePeerFeedbackSettings: async ({ assignmentId, requestBody, }) => {
            const result = await requestParams(config, 'PUT', `/api/v1/assignments/${assignmentId}/peer_feedback_settings`, updatePeerFeedbackSettingsResponse.v, JSON.stringify(UpdatePeerFeedbackSettingsAssignmentData.encode(requestBody)));
            return result;
        },
        /**
         * Assign graders to all the latest :class:.models.Work objects of the given :class:.models.Assignment.
         *
         * The redivide tries to minimize shuffles. This means that calling it twice with the same data is effectively a noop. If the relative weight (so the percentage of work) of a user doesn't change it will not lose or gain any submissions.
         *
         * If a user was marked as done grading and gets assigned new submissions this user is marked as not done and gets a notification email!
         *
         * @param arg The arguments to the function.
         * @param arg.assignmentId The id of the assignment
         * @param arg.requestBody The body of the request.
         * @returns An empty response with return code 204
         */
        divideGraders: async ({ assignmentId, requestBody, }) => {
            const result = await requestParams(config, 'PUT', `/api/v1/assignments/${assignmentId}/grader_division`, divideGradersResponse.v, JSON.stringify(DivideGradersAssignmentData.encode(requestBody)));
            return result;
        },
        /**
         * Generate a CSV report for this assignment.
         *
         * @param arg The arguments to the function.
         * @param arg.assignmentId The id of the assignment
         * @param arg.requestBody The body of the request.
         * @returns A CSV report for this assignment.
         */
        export: async ({ assignmentId, requestBody, }) => {
            const result = await requestParams(config, 'POST', `/api/v1/assignments/${assignmentId}/export`, exportResponse.v, JSON.stringify(ExportAssignmentData.encode(requestBody)));
            return result;
        },
        /**
         * Get the grades for all submissions in this assignment.
         *
         * @param arg The arguments to the function.
         * @param arg.assignmentId The id of assignment to export the gradebook for.
         * @param arg.pageSize The size of a single page, maximum is 200.
         * @param arg.nextToken The next token, to retrieve a next page.
         * @returns The rows of the gradebook.
         */
        getAllGrades: async ({ assignmentId, pageSize = undefined, nextToken = undefined, }) => {
            const result = await requestParams(config, 'GET', `/api/v1/assignments/${assignmentId}/grades/`, getAllGradesResponse.v, undefined, {
                'page-size': pageSize,
                'next-token': nextToken,
            });
            return result;
        },
        /**
         * Gets a list of all users that can grade in the given assignment.
         *
         * @param arg The arguments to the function.
         * @param arg.assignmentId The id of the assignment
         * @param arg.pageSize The size of a single page, maximum is 50.
         * @param arg.nextToken The next token, to retrieve a next page.
         * @returns A response containing the JSON serialized graders.
         */
        getAllGraders: async ({ assignmentId, pageSize = undefined, nextToken = undefined, }) => {
            const result = await requestParams(config, 'GET', `/api/v1/assignments/${assignmentId}/graders/`, getAllGradersResponse.v, undefined, {
                'page-size': pageSize,
                'next-token': nextToken,
            });
            return result;
        },
        /**
         * Return all submissions by the given user in the given assignment.
         *
         * For group assignments this route will also include submissions by the group of the user, which are always seen as later than the submission of the user.
         *
         * @param arg The arguments to the function.
         * @param arg.assignmentId The id of the assignment
         * @param arg.userId The user of which you want to get the submissions.
         * @param arg.pageSize The size of a single page, maximum is 50.
         * @param arg.nextToken The next token, to retrieve a next page.
         * @returns A response containing the JSON serialized submissions.
         */
        getSubmissionsByUser: async ({ assignmentId, userId, pageSize = undefined, nextToken = undefined, }) => {
            const result = await requestParams(config, 'GET', `/api/v1/assignments/${assignmentId}/users/${userId}/submissions/`, getSubmissionsByUserResponse.v, undefined, {
                'page-size': pageSize,
                'next-token': nextToken,
            });
            return result;
        },
        /**
         * Return all submissions for the given assignment.
         *
         * @param arg The arguments to the function.
         * @param arg.assignmentId The id of the assignment
         * @param arg.q Filter the submissions returned based on this string.
         * @param arg.testStudent If give only return submissions that either are or are not of the test student.
         * @param arg.pageSize The size of a single page, maximum is 100.
         * @param arg.nextToken The next token, to retrieve a next page.
         * @returns A response containing the JSON serialized submissions.
         */
        getAllSubmissions: async ({ assignmentId, q = undefined, testStudent = undefined, pageSize = undefined, nextToken = undefined, }) => {
            const result = await requestParams(config, 'GET', `/api/v1/assignments/${assignmentId}/submissions/`, getAllSubmissionsResponse.v, undefined, {
                q,
                test_student: testStudent,
                'page-size': pageSize,
                'next-token': nextToken,
            });
            return result;
        },
        /**
         * Get the data of an analytics source.
         *
         * the data. the data.
         *
         * @param arg The arguments to the function.
         * @param arg.assignmentId The id of the assignment from which you want to get the data.
         * @param arg.dataSourceName The name of the data source of which you wan to get the data.
         * @param arg.pageSize The size of a single page, maximum is 250.
         * @param arg.nextToken The next token, to retrieve a next page.
         * @returns A paginated list of the data.
         */
        getAnalyticsData: async ({ assignmentId, dataSourceName, pageSize = undefined, nextToken = undefined, }) => {
            const result = await requestParams(config, 'GET', `/api/v1/assignments/${assignmentId}/analytics/${dataSourceName}/data/`, getAnalyticsDataResponse.v, undefined, {
                'page-size': pageSize,
                'next-token': nextToken,
            });
            return result;
        },
        /**
         * Get all IP ranges for an assignment.
         *
         * @param arg The arguments to the function.
         * @param arg.assignmentId The ID of the assignment.
         * @param arg.pageSize The size of a single page, maximum is 100.
         * @param arg.nextToken The next token, to retrieve a next page.
         * @returns A JSON response containing the list of IP ranges.
         */
        getAllAllowedIps: async ({ assignmentId, pageSize = undefined, nextToken = undefined, }) => {
            const result = await requestParams(config, 'GET', `/api/v1/assignments/${assignmentId}/allowed_ips/`, getAllAllowedIpsResponse.v, undefined, {
                'page-size': pageSize,
                'next-token': nextToken,
            });
            return result;
        },
        /**
         * Get the schedule for the specified `Assignment`.
         *
         * @param arg The arguments to the function.
         * @param arg.assignmentId The id of the assignment;
         * @returns The assignment schedule.
         */
        getTimeframes: async ({ assignmentId, }) => {
            const result = await requestParams(config, 'GET', `/api/v1/assignments/${assignmentId}/timeframes/`, getTimeframesResponse.v, undefined);
            return result;
        },
        /**
         * Updates the schedule for the specified `Assignment`.
         *
         * @param arg The arguments to the function.
         * @param arg.assignmentId The id of the assignment;
         * @param arg.requestBody The body of the request.
         * @returns The updated assignment schedule.
         */
        putTimeframes: async ({ assignmentId, requestBody, }) => {
            const result = await requestParams(config, 'PUT', `/api/v1/assignments/${assignmentId}/timeframes/`, putTimeframesResponse.v, JSON.stringify(AssignmentTimeframes.encode(requestBody)));
            return result;
        },
        /**
         * Get the `AutoTest` for this assignment.
         *
         * @param arg The arguments to the function.
         * @param arg.assignmentId The id of the assignment from which you want to get the `AutoTest`.
         * @returns The `AutoTest` for the given assignment, if it has an `AutoTest`.
         */
        getAutoTest: async ({ assignmentId, }) => {
            const result = await requestParams(config, 'GET', `/api/v1/assignments/${assignmentId}/auto_test`, getAutoTestResponse.v, undefined);
            return result;
        },
        /**
         * Create or get the webhook settings to hand-in submissions.
         *
         * You can select the user for which the webhook should hand-in using the exact same query parameters as the route to upload a submission.
         *
         * @param arg The arguments to the function.
         * @param arg.assignmentId The assignment for which the webhook should hand-in submissions.
         * @param arg.webhookType The webhook type, currently only `git` is supported, which works for both GitLab and GitHub.
         * @param arg.authorId The id of the user for which we should get the webhook settings. If not given defaults to the current user.
         * @param arg.isTestSubmission Should we get the webhook settings for the test student.
         * @returns A serialized form of a webhook, which contains all data needed to add the webhook to your provider.
         */
        getWebhookSettings: async ({ assignmentId, webhookType, authorId = undefined, isTestSubmission = undefined, }) => {
            const result = await requestParams(config, 'POST', `/api/v1/assignments/${assignmentId}/webhook_settings`, getWebhookSettingsResponse.v, undefined, {
                webhook_type: webhookType,
                author_id: authorId,
                is_test_submission: isTestSubmission,
            });
            return result;
        },
        /**
         * Get the next ungraded submission for the given assignment.
         *
         * Returns the next ungraded submission assigned in the following order: 1. Those belonging to the current grader. 2. Those assigned to no grader. If no more ungraded submissions exist it returns 404.
         *
         * @param arg The arguments to the function.
         * @param arg.assignmentId The id of the assignment.
         * @param arg.currentSubmissionId The id of the submission to exclude in the search.
         * @returns The next ungraded submission that should be graded by the user.
         */
        getNextUngradedSubmission: async ({ assignmentId, currentSubmissionId = undefined, }) => {
            const result = await requestParams(config, 'GET', `/api/v1/assignments/${assignmentId}/next-ungraded-submission`, getNextUngradedSubmissionResponse.v, undefined, {
                current_submission_id: currentSubmissionId,
            });
            return result;
        },
        /**
         * Get the peer feedback subjects for a given user.
         *
         * This endpoint retrieves the list of subjects (i.e., other users or groups) that the specified user is assigned to review. It transparently handles both individual and group assignments.
         *
         * @param arg The arguments to the function.
         * @param arg.assignmentId The ID of the assignment.
         * @param arg.userId The ID of the user whose peer feedback duties are being requested. For group assignments, providing an individual member's ID will return the subjects assigned to their entire group.
         * @param arg.pageSize The size of a single page, maximum is 50.
         * @param arg.nextToken The next token, to retrieve a next page.
         * @returns A paginated list of peer feedback subjects. Returns an empty list if the assignment's feedback period is not active or if it is not a peer feedback assignment.
         */
        getPeerFeedbackSubjects: async ({ assignmentId, userId, pageSize = undefined, nextToken = undefined, }) => {
            const result = await requestParams(config, 'GET', `/api/v1/assignments/${assignmentId}/users/${userId}/peer_feedback_subjects/`, getPeerFeedbackSubjectsResponse.v, undefined, {
                'page-size': pageSize,
                'next-token': nextToken,
            });
            return result;
        },
        /**
         * Get all plagiarism runs for the given assignment.
         *
         * @param arg The arguments to the function.
         * @param arg.assignmentId The id of the assignment
         * @param arg.q Search the runs based on this value.
         * @param arg.pageSize The size of a single page, maximum is 50.
         * @param arg.nextToken The next token, to retrieve a next page.
         * @returns A response containing the JSON serialized list of plagiarism runs.
         */
        getAllPlagiarismRuns: async ({ assignmentId, q = undefined, pageSize = undefined, nextToken = undefined, }) => {
            const result = await requestParams(config, 'GET', `/api/v1/assignments/${assignmentId}/plagiarism/`, getAllPlagiarismRunsResponse.v, undefined, {
                q,
                'page-size': pageSize,
                'next-token': nextToken,
            });
            return result;
        },
        /**
         * Retrieves reply counts for a specific user, grouped by submission.
         *
         * This endpoint provides an efficient summary of a user's activity within an assignment. It's useful for analytics or dashboard views where you need to see how many replies a user has contributed to each submission without fetching the full comment data.
         *
         * @param arg The arguments to the function.
         * @param arg.assignmentId The ID of the assignment to scope the search to.
         * @param arg.userId The ID of the user whose replies are being counted.
         * @param arg.pageSize The size of a single page, maximum is 50.
         * @param arg.nextToken The next token, to retrieve a next page.
         * @returns A paginated response. The data payload is a list of objects, each mapping a submission's ID to the total count of replies the specified user made on it.
         */
        getReplyCountsForUser: async ({ assignmentId, userId, pageSize = undefined, nextToken = undefined, }) => {
            const result = await requestParams(config, 'GET', `/api/v1/assignments/${assignmentId}/users/${userId}/replies/counts-by-submission/`, getReplyCountsForUserResponse.v, undefined, {
                'page-size': pageSize,
                'next-token': nextToken,
            });
            return result;
        },
        /**
         * Import an assignment into another assignment.
         *
         * @param arg The arguments to the function.
         * @param arg.intoAssignmentId The assignment you want to import into.
         * @param arg.requestBody The body of the request.
         * @returns The updated assignment, so the assignment which was imported into.
         */
        importInto: async ({ intoAssignmentId, requestBody, }) => {
            const result = await requestParams(config, 'POST', `/api/v1/assignments/${intoAssignmentId}/import`, importIntoResponse.v, JSON.stringify(ImportIntoAssignmentData.encode(requestBody)));
            return result;
        },
        /**
         * Import a rubric from a different assignment.
         *
         * @param arg The arguments to the function.
         * @param arg.assignmentId The id of the assignment in which you want to import the rubric. This assignment shouldn't have a rubric.
         * @param arg.requestBody The body of the request.
         * @returns The rubric rows of the assignment in which the rubric was imported, so the assignment with id `assignment_id` and not `old_assignment_id`.
         */
        copyRubric: async ({ assignmentId, requestBody, }) => {
            const result = await requestParams(config, 'POST', `/api/v1/assignments/${assignmentId}/rubric`, copyRubricResponse.v, JSON.stringify(CopyRubricAssignmentData.encode(requestBody)));
            return result;
        },
        /**
         * Indicate that the given grader is done grading the given assignment.
         *
         * @param arg The arguments to the function.
         * @param arg.assignmentId The id of the assignment the grader is done grading.
         * @param arg.graderId The id of the `User` that is done grading.
         * @returns An empty response with return code 204
         */
        markGraderAsDone: async ({ assignmentId, graderId, }) => {
            const result = await requestParams(config, 'POST', `/api/v1/assignments/${assignmentId}/graders/${graderId}/done`, markGraderAsDoneResponse.v, undefined);
            return result;
        },
        /**
         * Indicate that the given grader is not yet done grading the given assignment.
         *
         * @param arg The arguments to the function.
         * @param arg.assignmentId The id of the assignment the grader is not yet done grading.
         * @param arg.graderId The id of the `User` that is not yet done grading.
         * @returns An empty response with return code 204
         */
        markGraderAsNotDone: async ({ assignmentId, graderId, }) => {
            const result = await requestParams(config, 'DELETE', `/api/v1/assignments/${assignmentId}/graders/${graderId}/done`, markGraderAsNotDoneResponse.v, undefined);
            return result;
        },
        /**
         * Run a plagiarism checker for the given `Assignment`.
         *
         * @param arg The arguments to the function.
         * @param arg.assignmentId The id of the assignment
         * @param arg.requestBody The body of the request.
         * @returns The json serialization newly created
         */
        createPlagiarismRun: async ({ assignmentId, requestBody, }) => {
            const body = coreUtils.toFormData(CreatePlagiarismRunAssignmentData.encode(requestBody));
            const result = await requestParams(config, 'POST', `/api/v1/assignments/${assignmentId}/plagiarism`, createPlagiarismRunResponse.v, body);
            return result;
        },
        /**
         * Update the given assignment editor template with new files.
         *
         * How this route deals with existing editor templates when submitting is still experimental and might change in an upcoming release.
         *
         * @param arg The arguments to the function.
         * @param arg.assignmentId The id of the assignment for which you want to update the editor template.
         * @param arg.requestBody The body of the request.
         * @returns The updated assignment.
         */
        patchSubmitTypes: async ({ assignmentId, requestBody, }) => {
            const body = coreUtils.toFormData(PatchSubmitTypesAssignmentData.encode(requestBody));
            const result = await requestParams(config, 'PATCH', `/api/v1/assignments/${assignmentId}/submit_types`, patchSubmitTypesResponse.v, body);
            return result;
        },
        /**
         * Upload one or more files as `Work` to the given `Assignment`.
         *
         * @param arg The arguments to the function.
         * @param arg.assignmentId The id of the assignment
         * @param arg.requestBody The body of the request.
         * @param arg.authorId The id of the user for which we should get the webhook settings. If not given defaults to the current user.
         * @param arg.isTestSubmission Should we get the webhook settings for the test student.
         * @param arg.ignoredFiles How to handle ignored files. The options are: `keep`: this the default, sipmly do nothing about ignored files. `delete`: delete the ignored files. `error`: return an error when there are ignored files in the archive.
         * @returns The created work.
         */
        uploadSubmission: async ({ assignmentId, requestBody, authorId = undefined, isTestSubmission = undefined, ignoredFiles = undefined, }) => {
            const body = coreUtils.toFormData(UploadSubmissionAssignmentData.encode(requestBody));
            const result = await requestParams(config, 'POST', `/api/v1/assignments/${assignmentId}/submission`, uploadSubmissionResponse.v, body, {
                author_id: authorId,
                is_test_submission: isTestSubmission,
                ignored_files: ignoredFiles,
            });
            return result;
        },
        /**
         * Verify a password for an assignment.
         *
         * @param arg The arguments to the function.
         * @param arg.assignmentId The id of the assignment.
         * @param arg.requestBody The body of the request.
         * @returns An empty response if valid, error if invalid.
         */
        verify: async ({ assignmentId, requestBody, }) => {
            const result = await requestParams(config, 'POST', `/api/v1/assignments/${assignmentId}/verify`, verifyResponse.v, JSON.stringify(VerifyAssignmentData.encode(requestBody)));
            return result;
        },
    });
}
